import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import React, { useEffect } from "react";
import CreateDeviation from "./CreateDeviation";
import DeviationHistory from "./DeviationHistory";
import { useDispatch } from "react-redux";
import { getLatestBurdenAPI } from "../../Redux/App/app.actions";

const Deviations = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getLatestBurdenAPI());
  }, []);

  return (
    <Box w="99%" m="auto">
      <Tabs w="100%">
        <TabList mb="1em">
          <Tab
            _selected={{
              borderBottom: "3px solid #1a174e",
              backgroundColor: "gray.200",
              borderRadius: "5px 5px 0 0",
            }}
            w="25%"
          >
            CREATE NEW DEVIATION
          </Tab>
          <Tab
            _selected={{
              borderBottom: "3px solid #1a174e",
              backgroundColor: "gray.200",
              borderRadius: "5px 5px 0 0",
            }}
            w="25%"
          >
            PAST DEVIATIONS
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <CreateDeviation />
          </TabPanel>
          <TabPanel>
            <DeviationHistory />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default Deviations;
